import { useState, useEffect } from 'react';

const cache = new Map();
const FORMAT_URL = '/.netlify/functions/format-description';

export function useFormattedDescription(book) {
  const [formatted, setFormatted] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const description = book?.description;
    if (!book || !description) {
      setFormatted(null);
      setLoading(false);
      return;
    }

    const cacheKey = book.key;
    if (cache.has(cacheKey)) {
      setFormatted(cache.get(cacheKey));
      setLoading(false);
      return;
    }

    setFormatted(null);
    setLoading(true);

    fetch(FORMAT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        description,
        title: book.title,
        author: book.author,
      }),
    })
      .then(r => r.json())
      .then(({ description: result }) => {
        const value = result ?? description;
        cache.set(cacheKey, value);
        setFormatted(value);
      })
      .catch(() => {
        cache.set(cacheKey, description);
        setFormatted(description);
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [book?.key]);

  return { formatted, loading };
}
